var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getUiOptions } from "../utils/";

var defaultProps = {
    defaultFormData: {},
    defaultOptions: {},
    defaultSchema: {
        "type": "object",
        "properties": {}
    }
};

function getSchema(props) {
    var schema = props.schema,
        defaultSchema = props.defaultSchema,
        registry = props.registry;
    var _registry$formContext = registry.formContext,
        languages = _registry$formContext.languages,
        language = _registry$formContext.language;


    var fieldSchema = {
        type: "object",
        properties: {}
    };

    languages.map(function (id) {

        var localeId = "locale:" + id;

        fieldSchema.properties[localeId] = {
            type: "string"
        };
    });

    return fieldSchema;
}

function getUiSchema(props) {
    var schema = props.schema,
        uiSchema = props.uiSchema,
        defaultOptions = props.defaultOptions,
        registry = props.registry;
    var _registry$formContext2 = registry.formContext,
        languages = _registry$formContext2.languages,
        language = _registry$formContext2.language;


    var options = getUiOptions(uiSchema);

    var localizedUiSchema = {};

    languages.map(function (id) {
        var localeId = "locale:" + id;
        var hidden = language !== id;

        localizedUiSchema[localeId] = {
            "ui:options": _extends({}, options, {
                "language": id
            }),
            "ui:hidden": hidden
        };
    });

    return _extends({}, localizedUiSchema);

    return _extends({}, localizedUiSchema, {
        "ui:options": _extends({}, defaultOptions)
    });
}

function getFormData(props) {
    var formData = props.formData,
        defaultFormData = props.defaultFormData;


    formData = _extends({}, defaultFormData, formData);

    return formData;
}

export default function getField(props) {

    props = _extends({}, defaultProps, props);

    var schema = getSchema(props);
    var uiSchema = getUiSchema(_extends({}, props, { schema: schema }));
    var formData = getFormData(_extends({}, props, { schema: schema, uiSchema: uiSchema }));

    return _extends({}, props, {
        schema: schema,
        uiSchema: uiSchema,
        formData: formData
    });
}